// Code Based off Kirsten Allen's Codepen: https://codepen.io/kirstenallen/pen/MWwPYYm
import { animated } from 'react-spring';
import styled, { keyframes } from 'styled-components';
import { Text, View, VStack } from 'native-base';

export interface MapChatMessageBubbleProps {
  lastMessage: string;
  backgroundColor: string;
}

const float1 = keyframes`
  0% { transform: translatey(0px) }
  50% { transform: translatey(-10px) }
  100% { transform: translatey(0px) }
  `;

const float2 = keyframes`
  0% { transform: translatey(0px) }
  55% { transform: translatey(-10px) }
  100% { transform: translatey(0px) }
  `;

const float3 = keyframes`
  0% { transform: translatey(0px) }
  60% { transform: translatey(-10px) }
  100% { transform: translatey(0px) }
  `;

const ChatBubble = styled.div`
  animation-name: ${float1};
  animation-duration: 5s;
  animation-iteration-count: infinite;
`;

const ChatBubble2 = styled.div`
  animation-name: ${float2};
  animation-duration: 5s;
  animation-iteration-count: infinite;
`;

const ChatBubble3 = styled.div`
  animation-name: ${float3};
  animation-duration: 5s;
  animation-iteration-count: infinite;
`;

const AnimatedBubble = animated(ChatBubble);
const AnimatedBubble2 = animated(ChatBubble2);
const AnimatedBubble3 = animated(ChatBubble3);

export function MapChatMessageBubble({
  lastMessage,
  backgroundColor,
}: MapChatMessageBubbleProps) {
  return (
    <VStack paddingLeft={10} maxWidth={'300px'} alignItems={'flex-start'}>
      <AnimatedBubble>
        <View
          marginLeft={1.5}
          px={5}
          py={2.5}
          bg={backgroundColor}
          rounded={'full'}
          style={{
            shadowColor: 'rgba(0, 0, 0, 0.50)',
            shadowOpacity: 0.5,
            shadowRadius: 30,
            shadowOffset: { width: 2, height: 2 },
          }}
        >
          <Text numberOfLines={1}>
            {lastMessage.length > 25
              ? `${lastMessage.slice(0, 25)}...`
              : `${lastMessage}`}
          </Text>
        </View>
      </AnimatedBubble>
      <AnimatedBubble2>
        <View
          marginLeft={1}
          px={3}
          py={1.5}
          bg={backgroundColor}
          rounded={'full'}
          style={{
            shadowColor: 'rgba(0, 0, 0, 0.50)',
            shadowOpacity: 0.5,
            shadowRadius: 30,
            shadowOffset: { width: 2, height: 2 },
          }}
        />
      </AnimatedBubble2>
      <AnimatedBubble3>
        <View
          p={1}
          bg={backgroundColor}
          rounded={'full'}
          style={{
            shadowColor: 'rgba(0, 0, 0, 0.50)',
            shadowOpacity: 0.5,
            shadowRadius: 30,
            shadowOffset: { width: 2, height: 2 },
          }}
        />
      </AnimatedBubble3>
    </VStack>
  );
}

export default MapChatMessageBubble;
